import React from 'react';
import UserOrganizationsList from './UserOrganizationsList';

function UserOrganizations() {
  return <UserOrganizationsList />;
}
export default UserOrganizations;
